// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container__SkIPm","title":"index_title__18t40","list":"index_list__TWX4X"};